export default __webpack_public_path__ + "static/media/DEP.53c3db94.png";